import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import { useAuth } from '@features/auth'
import useClearOutStockCart from '@features/cart/hooks/useClearOutStockCart'
import { useCartStore } from '@features/cart/model/useCartStore'
import { useErrorInfoModal } from '@features/modal'

import Button from '@shared/ui/button'

import styles from './styles.module.scss'



export default function ClearOutStockCartModal () {
  const { t: tc } = useTranslation('common')
  const { removeZeroAmountItemsInCurrentCart } = useCartStore()
  const { closeClearOutStockModal } = useClearOutStockCart()
  const { isAuthorized } = useAuth()
  const { openErrorInfoModal } = useErrorInfoModal()

  const isTablet = useMediaQuery('(max-width: 768px)')
  const buttonSize = isTablet ? 'medium' : 'large'

  const handleClearCart = async () => {
    try {
      await removeZeroAmountItemsInCurrentCart(isAuthorized)

      closeClearOutStockModal()
    }
    catch (error) {
      console.error('fetchClearCart error: ', error)
      openErrorInfoModal({
        description: tc('clear_cart'),
      })
    }
  }

  return (
    <div className={styles.modal}>
      <Button onClick={handleClearCart} size={buttonSize}>
        {tc('yes')}
      </Button>
      <Button onClick={closeClearOutStockModal} theme="grey" size={buttonSize}>
        {tc('no')}
      </Button>
    </div>
  )
}
